import gql from 'graphql-tag';

export const DEAL_SHEET_CONFIGURATION_FRAGMENT = gql`
  fragment DealSheetConfig on DealSheetConfigurationViewModel {
    id
    name
    isGlobal
    description
    charges {
      data {
        id
        name
        type
        amount
        parentId
        sortOrder
        isTaxable
        amountType
        equipmentId
        description
        isEquipmentLvl
        customerVisibility
        cap {
          min
          max
        }
      }
    }

    dealRules {
      location
      customer
      equipment
    }

    createdBy {
      id
      email
      fullName
    }

    updatedDateTime
    createdDateTime
  }
`;
